<template>
  <div class="reglement-card">
    <div class="frame clickable-frame" @click="openRegulation('ce-834-2007')">
      <div class="container">
        <div class="div eu-background">
          <div class="background-overlay"></div>
          <img
            class="icon-country"
            alt="ue"
            src="/img/emojione-flag-for-european-union.svg"
          />
        </div>
      </div>

      <div class="title-wrapper">
        <p class="title">
          Règlementation européenne régissant les produits issus de
          l&apos;agriculture biologique
        </p>
      </div>

      <div class="chips-group">
        <button class="button blue" @click="openRegulation('ce-889-2008')">
          <div class="button-text">Règlement CE 889-2008</div>
        </button>

        <button class="button blue" @click="openRegulation('ce-834-2007')">
          <div class="button-text">Règlement CE 834-2007</div>
        </button>
      </div>
    </div>

    <div class="frame clickable-frame" @click="openRegulation('nop')">
      <div class="container">
        <div class="div usa-background">
          <div class="background-overlay"></div>
          <img class="icon-country" alt="usa" src="/img/flagpack_us.png" />
        </div>
      </div>

      <div class="title-wrapper">
        <p class="title">
          Règlementation américaine régissant les produits issus de
          l&apos;agriculture biologique
        </p>
      </div>

      <div class="chips-group">
        <button class="button red" @click="openRegulation('nop')">
          <div class="button-text">National Organic Products</div>
        </button>

        <button class="button red" @click="openRegulation('nop-guide')">
          <div class="button-text">Guide du NOP</div>
        </button>
      </div>
    </div>

    <div class="frame clickable-frame" @click="openRegulation('japan-maff')">
      <div class="container">
        <div class="div japan-background">
          <div class="background-overlay"></div>
          <img
            class="icon-country"
            alt="japan"
            src="/img/twemoji-flag-japan.svg"
          />
        </div>
      </div>

      <div class="title-wrapper">
        <p class="title">
          Règlementation japonaise régissant les produits issus de
          l&apos;agriculture biologique
        </p>
      </div>

      <div class="chips-group">
        <button class="button red" @click="openRegulation('japan-maff')">
          <div class="button-text">www.maff.go.jp</div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReglementCard",
  methods: {
    openRegulation(type) {
      const regulations = {
        'ce-889-2008': 'https://eur-lex.europa.eu/legal-content/FR/TXT/?uri=CELEX%3A32008R0889',
        'ce-834-2007': 'https://eur-lex.europa.eu/legal-content/FR/TXT/?uri=CELEX%3A32007R0834',
        'nop': 'https://www.ams.usda.gov/about-ams/programs-offices/national-organic-program',
        'nop-guide': 'https://www.ams.usda.gov/sites/default/files/media/Organic%20Labeling%20Standards.pdf',
        'japan-maff': 'https://www.maff.go.jp/e/policies/standard/organicag/'
      };
      
      const url = regulations[type];
      if (url) {
        window.open(url, '_blank');
      }
    }
  }
};
</script>

<style>
.reglement-card {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  gap: 24px 24px;
  margin: 24px 9vw 64px 9vw;
  /* left: 104px; */
  /* position: absolute; */
  /* top: 1218px; */
  /* width: 1232px; */
}

.reglement-card .frame {
  align-items: flex-start;
  display: flex;
  flex: 1;
  flex-direction: column;
  flex-grow: 1;
  gap: 12px;
  /* position: relative; */
}

.reglement-card .clickable-frame {
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 12px;
  padding: 8px;
  margin: -8px;
}

.reglement-card .clickable-frame:hover {
  background-color: rgba(0, 0, 0, 0.02);
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.reglement-card .container {
  align-items: flex-start;
  align-self: stretch;
  border-radius: 12px;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
  overflow: hidden;
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.reglement-card .div {
  align-items: flex-start;
  align-self: stretch;
  background-color: #eeeeee;
  display: flex;
  gap: 10px;
  height: 202px;
  padding: 21px 12px;
  position: relative;
  width: 100%;
  overflow: hidden;
}

.reglement-card .background-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.4) 100%);
  z-index: 1;
}

.reglement-card .eu-background {
  background: linear-gradient(135deg, #003399 0%, #FFCC00 100%),
              url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="stars" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse"><circle cx="10" cy="10" r="1" fill="%23FFCC00" opacity="0.3"/></pattern></defs><rect width="100" height="100" fill="url(%23stars)"/></svg>');
  background-size: cover, 40px 40px;
}

.reglement-card .usa-background {
  background: linear-gradient(135deg, #B22234 0%, #FFFFFF 50%, #3C3B6E 100%),
              url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="stripes" x="0" y="0" width="100" height="8" patternUnits="userSpaceOnUse"><rect width="100" height="4" fill="%23FFFFFF" opacity="0.1"/><rect y="4" width="100" height="4" fill="%23B22234" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23stripes)"/></svg>');
  background-size: cover, 100px 16px;
}

.reglement-card .japan-background {
  background: linear-gradient(135deg, #FFFFFF 0%, #BC002D 100%),
              url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="sakura" x="0" y="0" width="25" height="25" patternUnits="userSpaceOnUse"><g opacity="0.2"><path d="M12.5,5 L15,12 L22,10 L17,15 L22,20 L15,18 L12.5,25 L10,18 L3,20 L8,15 L3,10 L10,12 Z" fill="%23FFB7C5"/></g></pattern></defs><rect width="100" height="100" fill="url(%23sakura)"/></svg>');
  background-size: cover, 50px 50px;
}

.reglement-card .icon-country {
  height: 64px;
  width: 64px;
  border-radius: 100px;
  overflow: hidden;
  position: relative;
  z-index: 2;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 3px solid rgba(255, 255, 255, 0.8);
}

.reglement-card .title-wrapper {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  gap: 10px;
  /* min-height: 144px; */
  /* position: relative; */
  width: 100%;
  padding: 12px 12px;
}

.reglement-card .title {
  color: #000000;
  flex: 1;
  font-family: "Bw Modelica SS02";
  font-size: 1.4vw;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 4vh;
  /* margin-top: -1.00px; */
  /* position: relative; */
}

.reglement-card .chips-group {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  gap: 4px 4px;
  margin-left: 12px;
  /* padding: 0px 12px; */
  /* position: relative; */
  width: 100%;
}

.reglement-card .button {
  all: unset;
  align-items: center;
  border-radius: 100px;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 10px;
  justify-content: center;
  padding: 2px 12px;
  transition: all 0.3s ease;
  /* position: relative; */
}

.reglement-card .button:hover {
  opacity: 0.8;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.reglement-card .blue{
  background-color: #2a5f9e;
}
.reglement-card .red{
  background-color: #e31d1c;
}
.reglement-card .button-text {
  color: #ffffff;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: -1.00px;
  /* position: relative; */
  white-space: nowrap;
  width: fit-content;
}
@media (max-width: 1200px){
  .reglement-card {
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding-bottom: 16px;
  }
  .reglement-card::-webkit-scrollbar {
    display: none;
  }
  .reglement-card .frame {
    flex: 0 0 350px;
    width: 350px;
  }
  .reglement-card .title {
    font-size: 18px;
    line-height: 24px;
  }
  .reglement-card .icon-country {
    height: 48px;
    width: 48px;
  }
}

@media (max-width: 768px) {
  .reglement-card {
    margin-left: 6vw;
    margin-right: 6vw;
  }
  .reglement-card .frame {
    flex: 0 0 80vw;
    width: 80vw;
  }
  .reglement-card .title {
    font-size: 16px;
    line-height: 22px;
  }
  .reglement-card .div {
    height: 180px;
  }
}

@media (max-width: 480px) {
  .reglement-card {
    margin-left: 4vw;
    margin-right: 4vw;
  }
  .reglement-card .frame {
    flex: 0 0 85vw;
    width: 85vw;
  }
  .reglement-card .title {
    font-size: 15px;
    line-height: 20px;
  }
  .reglement-card .div {
    height: 160px;
  }
  .reglement-card .icon-country {
    height: 40px;
    width: 40px;
  }
  .reglement-card .button-text {
    font-size: 12px;
  }
}

</style>